// extracted by mini-css-extract-plugin
module.exports = {"link":"_1X5Vd","root":"_3WpKk","wrapper":"_1BjRI","container":"_23HBN","bottom":"MKYOz","ribbon":"_1dEyR","top":"_1tfaK","label":"o8U0x"};